import { DataTablePagination, PanelInfo } from '@/components/custom';
import Loader from '@/components/custom/Loader';
import { useCreators } from '../hooks';
import { Podcast } from 'lucide-react';
import DataTable from './dataTable';

const ViewData = () => {

  const { isLoading, data, creators } = useCreators();

  if (isLoading) {
    return (
      <div className='my-10'>
        <Loader className='my-10' />
      </div>
    );
  }

  if (creators.length === 0) {
    return (
      <PanelInfo
        title='Aucun créateur trouvé'
        description={`Il n'existe pas de créateur respectant ces critères.`}
        className='py-10 md:py-26 border-none'
        icon={Podcast} />
    );
  }

  return (
    <div className='space-y-5 animate__animated animate__fadeIn'>
      <DataTable />
      <DataTablePagination pageCount={data.pagination.pageCount} />
    </div>
  );

};

export default ViewData;
